import React from "react";

const DashboardCard = ({
  title,
  amount,
  paragraph,
  percentage,
  textColor,
  paragraphColor,
  bgColor,
  className,
  completedProjects,
}) => {
  return (
    <div
      className={`w-full flex flex-col gap-y-2 ${bgColor} px-6 py-4 border-r ${className}`}
    >
      <p className={`text-[12px] font-light ${textColor}`}>{title}</p>
      {amount === 0 || amount ? (
        <p className={`text-[24px] font-semibold ${textColor}`}>
          {`N${amount}.00`}
        </p>
      ) : (
        <p className={`text-[24px] font-semibold ${textColor}`}>
          {completedProjects}
        </p>
      )}
      <p className={`text-[14px] font-light ${textColor}`}>
        <span className={paragraphColor}>{percentage}</span> {paragraph}
      </p>
    </div>
  );
};

export default DashboardCard;
